import React from 'react';
import './Services.css';
import Title from '../../components/Title/Title';
import logoSeparator from '../../assets/LogoSeparator.png';
import Button from '../../components/Button/Button';

const Services: React.FC = () => {
  return (
    <div id="services">
      <div className="services">
        <Title>Nossos treinamentos</Title>

        <div className="services-content">

          {/* Aprofundando o Espermograma */}
          <div className="services-item">
            <div className="item-title">Aprofundando o Espermograma</div>
            <div className="item-badge">Online - Ao Vivo</div>
            <div className="item-section">
              <div className="item-subtitle">Sobre</div>
              <p>Fornecer uma atualização para os profissionais do laboratório para executarem todas as etapas do espermograma com segurança e padronização, segundo o manual da OMS 2021.</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Carga Horária</div>
              <p>2 horas</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Conteúdo</div>
              <ol className="item-content-list">
                <li>Agendamento e Recepção<span className="item-detail"> (Fluxos de atendimento, Documentos necessários)</span></li>
                <li>Coleta<span className="item-detail"> (Estrutura da sala de coleta, Orientações e formulário de coleta)</span></li>
                <li>Análises Macroscópicas<span className="item-detail"> (Liquefação, Volume, Viscosidade, Cor, pH)</span></li>
                <li>Análises Microscópicas<span className="item-detail"> (Motilidade, Aglutinação e agregação, Concentração, Células redondas, Vitalidade)</span></li>
                <li>Espermograma Pós-Vasectomia<span className="item-detail"> (Procedimento, Recomendações)</span></li>
                <li>Liberação e Interpretação do Laudo<span className="item-detail"> (Padronização, Valores de referência, Observações)</span></li>
              </ol>
            </div>
            <a href="#contact" style={{marginTop: 'auto'}}>
              <Button onPress={() => null}>Solicitar orçamento</Button>
            </a>
          </div>

          {/* Morfologia Estrita - Kruger */}
          <div className="services-item">
            <div className="item-title">Morfologia Estrita - Kruger</div>
            <div className="item-badge">Online - Ao Vivo</div>
            <div className="item-section">
              <div className="item-subtitle">Sobre</div>
              <p>Fornecer um treinamento teórico/prático para os profissionais do laboratório executarem a análise de morfologia estrita, pelo método de Kruger com segurança e padronização, segundo o manual da OMS 2021.</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Carga Horária</div>
              <p>1 hora</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Conteúdo</div>
              <ol className="item-content-list">
                <li>Sistema reprodutor masculino<span className="item-detail"> (Formação do sêmen, Estrutura do espermatozoide)</span></li>
                <li>Porque utilizar Kruger?<span className="item-detail"> (Análise convencional x Kruger)</span></li>
                <li>Espermatozoide normal<span className="item-detail"> (Cabeça, Peça-intermediária, Cauda)</span></li>
                <li>Confecção das lâminas<span className="item-detail"> (Esfregaço, Corantes, Dicas)</span></li>
                <li>Defeitos</li>
                <li>Liberação e Interpretação do Laudo<span className="item-detail"> (Padronização, Valores de referência, Observações)</span></li>
              </ol>
            </div>
            <a href="#contact" style={{marginTop: 'auto'}}>
              <Button onPress={() => null}>Solicitar orçamento</Button>
            </a>
          </div>

          {/* Fragmentação de DNA Espermático */}
          <div className="services-item">
            <div className="item-title">Fragmentação de DNA Espermático</div>
            <div className="item-badge">Online - Ao Vivo</div>
            <div className="item-section">
              <div className="item-subtitle">Sobre</div>
              <p>Fornecer um treinamento teórico/prático para os profissionais do laboratório executarem a fragmentação de DNA espermático, com segurança e padronização, segundo o manual da OMS 2021.</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Carga Horária</div>
              <p>1 hora</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Conteúdo</div>
              <ol className="item-content-list">
                <li>Mecanismos da Fragmentação de DNA Espermático</li>
                <li>Interpretação</li>
                <li>Métodos de Análise</li>
                <li>Etapas do Teste</li>
                <li>Análise</li>
                <li>Liberação e Interpretação do Laudo</li>
              </ol>
            </div>
            <a href="#contact" style={{marginTop: 'auto'}}>
              <Button onPress={() => null}>Solicitar orçamento</Button>
            </a>
          </div>

          {/* Espermograma Expert */}
          <div className="services-item services-item-presencial">
            <div className="item-title">Espermograma Expert</div>
            <div className="item-badge item-badge-presencial">Presencial</div>
            <div className="item-section">
              <div className="item-subtitle">Sobre</div>
              <p>Fornecer um treinamento completo, técnico e personalizado para capacitar os profissionais do laboratório a executar todas as etapas do espermograma com segurança e padronização, segundo o manual da OMS 2021.</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Carga Horária</div>
              <p>8 horas</p>
            </div>
            <div className="item-section">
              <div className="item-subtitle">Conteúdo</div>
              <ol className="item-content-list">
                <li>Agendamento e Recepção<span className="item-detail"> (Fluxos de atendimento, Documentos necessários)</span></li>
                <li>Coleta<span className="item-detail"> (Estrutura da sala de coleta, Orientações e formulário de coleta)</span></li>
                <li>Análises Macroscópicas<span className="item-detail"> (Liquefação, Volume, Viscosidade, Cor, pH)</span></li>
                <li>Análises Microscópicas<span className="item-detail"> (Motilidade, Aglutinação e agregação, Concentração, Células redondas, Vitalidade)</span></li>
                <li>Morfologia Estrita - método de Kruger<span className="item-detail"> (Preparo das lâminas, Coloração, Análise dos defeitos)</span></li>
                <li>Espermograma Pós-Vasectomia<span className="item-detail"> (Procedimento, Recomendações)</span></li>
                <li>Fragmentação de DNA Espermático<span className="item-detail"> (Conceito e aplicabilidade, Confecção das lâminas, Análise)</span></li>
                <li>Liberação e Interpretação do Laudo<span className="item-detail"> (Padronização, Valores de referência, Observações)</span></li>
              </ol>
            </div>
            <a href="#contact" style={{marginTop: 'auto'}}>
              <Button onPress={() => null}>Solicitar orçamento</Button>
            </a>
          </div>
        </div>

        <div className='advise'>*Os treinamentos <b>online</b> são realizados exclusivamente com a sua equipe, com horário agendado e ao vivo.</div>
        <div className='advise'>*O treinamento <b>presencial</b> são ministrados/supervisionados por Crislaine e/ou Letícia em um laboratório parceiro em Gaspar/SC ou Florianópolis/SC, com a sua equipe.</div>
      </div>
      <div className="separator">
        <div style={{fontSize: 22}}> Mais do que oferecer um treinamento</div>
        <h1>Queremos ser parceiros do seu laboratório!</h1>
        <img src={logoSeparator} alt="Logo" className="logo-separator" />
      </div>
    </div>
  );
};

export default Services;
